import { useEffect, useRef } from 'react'

import { resolveSelectedSpecialties } from '~/store/resolveSelectedSpecialties'
import { useStore } from '~/store/store'
import { selectDepartment, useDepartments } from '~/storm'
import { useAssignableSpecialities } from '~/storm/common/specialty'

/**
 * On first load, fill an empty specialty selection with the selected department's
 * specialties. Runs once DI entities are available, since resolution needs them.
 */
export function useResolveSelectedSpecialties() {
    const departments = useDepartments()
    const specialities = useAssignableSpecialities()
    const hasResolved = useRef(false)

    useEffect(() => {
        if (hasResolved.current || departments.length === 0 || specialities.length === 0) return

        const state = useStore.getState()
        const { departmentKey, selectedSpecialties, actions } = state.appFilters

        // A specific department must be resolvable before resolving; otherwise resolution
        // falls back to 'all'. Wait for the entity to load and rerun when it appears.
        if (departmentKey !== 'all' && !selectDepartment(state, { where: { id: departmentKey } })) return

        const resolved = resolveSelectedSpecialties(state, departmentKey, selectedSpecialties)

        hasResolved.current = true
        if (resolved !== selectedSpecialties) actions.setSelectedSpecialties(resolved)
    }, [departments.length, specialities.length])
}
